var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-rank",class:'rank-' + _vm.rank},[_c('div',{staticClass:"rank-inner"},[_c('img',{attrs:{"src":require('@/assets/img/ranks/' + _vm.rank + '.svg')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }